// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__38TgB","large":"styles_large__1SXCB"};